
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'
import BUSINESS_DATA from '@/configs/businessConstants';
import i18n from '@/plugins/i18n'

const PageConst= {
  ACTION: {
    doAdd: { api: 'M1031MailSettingService.M20701_doAdd'},
    getEdit: { api: 'M1031MailSettingService.M20701_getEdit'},
    doEdit: { api: 'M1031MailSettingService.M20701_doEdit'},
    doRead: { api: 'M1031MailSettingService.M20701_doRead'},
    doDelete: { api: 'M1031MailSettingService.M20701_doDelete'},
    doBrowse: { api: 'M1031MailSettingService.M20701_doBrowse'},
  },
}

const module = {
  state: {
    PageConst,
  },

  getters: {
    getDropdownList (state){
      return {
        notification_type: [
          { label: window.vue.$i18n.t('M20701.M20701Store.siRI01KC10Wln76icxAlh'), value: 1 },
          { label: window.vue.$i18n.t('M20701.M20701Store.6T_tfaQGwRW3hEFmOp9Yz'), value: 2 },
          { label: window.vue.$i18n.t('M20701.M20701Store.OuNwLRzPbxhQKyqc7WQte'), value: 3 }
        ]
      }
    },
    getNotificationTypeData (state){
      return {
      // 追加申込
        1: {
          availableVariables:[
            { label: window.vue.$i18n.t('M20701.M20701Store.lgqjsltgb26gwr_UHdjaR'), placeholder: '{# $Name #}' },
            { label: window.vue.$i18n.t('M20201.Edit.vZB3k7CCdZy3cpUuCJhzy'), placeholder: '{# $ClassRoomID #}' },
            { label: window.vue.$i18n.t('C20101.Edit.xue-nian'), placeholder: '{# $Grade #}' },
            { label: window.vue.$i18n.t('M20701.M20701Store.vr2PuD6gVGG2F2SNJG_3T'), placeholder: '{# $Course #}' },
            { label: window.vue.$i18n.t('M20701.M20701Store.RV6SMS6HmgqnRKSze6pjV'), placeholder: '{# $ApplicateCount #}' },
            { label: window.vue.$i18n.t('M20701.M20701Store._2qgziQmJL_SwBPPU_GwF'), placeholder: '{# $ApplicateInfo #}' },
            { label: window.vue.$i18n.t('M20701.M20701Store.McxooMSAKRQgMc0y9PxSb'), placeholder: '{# $Request #}' }
          ],
          Name: BUSINESS_DATA.APP_SHORT_TITLE+'太郎',
          Grade: '小６',
          ClassRoomID: 'h001',
          Course: '40分(後半)',
          ApplicateCount: 2,
          ApplicateInfo: '科目：国語ｱﾄﾞﾊﾞﾝｽ&nbsp;&nbsp;小６&nbsp;&nbsp;１:１<br />&nbsp;07/17(木)&nbsp;6講（後半）&nbsp;(19:10~19:50)<br />科目：数(算)ｱﾄﾞﾊﾞﾝｽ&nbsp;&nbsp;小６&nbsp;&nbsp;１:１<br />&nbsp;07/18(金)&nbsp;6講（後半）&nbsp;(19:10~19:50)<br />',
          Request: window.vue.$i18n.t('M20701.M20701Store.bkP2tC-i5NwJVp4XjVBUP'),
        },
        // 講習申込
        2: {
          availableVariables:[
            { label: window.vue.$i18n.t('M20701.M20701Store.rgy2fqj7_FGOD4avCdt3o'), placeholder: '{# $Name #}' },
            { label: window.vue.$i18n.t('M20201.Edit.vZB3k7CCdZy3cpUuCJhzy'), placeholder: '{# $ClassRoomID #}' },
            { label: window.vue.$i18n.t('C20101.Edit.xue-nian'), placeholder: '{# $Grade #}' },
            { label: window.vue.$i18n.t('M20701.M20701Store.mz-drAO1l2NZGmvG7LIBG'), placeholder: '{# $Course #}' },
            { label: window.vue.$i18n.t('M20701.M20701Store.ovvzouEFaArL_cZTEOepO'), placeholder: '{# $ApplicateCount #}' },
            { label: window.vue.$i18n.t('M20701.M20701Store.YJSbPOZudxjLvV8LdncWn'), placeholder: '{# $ApplicateInfo #}' },
            { label: window.vue.$i18n.t('M20701.M20701Store.6O8PVRKsp9mwE4PKZvKbT'), placeholder: '{# $Request #}' }
          ],
          Name: BUSINESS_DATA.APP_SHORT_TITLE+'太郎',
          Grade: '小６',
          ClassRoomID: 'h001',
          Course: '40分(前半)',
          ApplicateCount: 2,
          ApplicateInfo: '科目：国語ｱﾄﾞﾊﾞﾝｽ&nbsp;&nbsp;小６&nbsp;&nbsp;１:１<br />&nbsp;07/17(木)&nbsp;7講（前半）&nbsp;(20:00~20:40)[追加]<br />科目：数(算)ｱﾄﾞﾊﾞﾝｽ&nbsp;&nbsp;小６&nbsp;&nbsp;１:１<br />&nbsp;07/18(金)&nbsp;7講（前半）&nbsp;(20:00~20:40)[追加]<br />',
          Request: 'Test Request',
        },
        // 振替申込
        3: {
          availableVariables:[
            { label: window.vue.$i18n.t('M20701.M20701Store.cBQJyeqpHgfNyEG-X0FL6'), placeholder: '{# $Name #}' },
            { label: window.vue.$i18n.t('M20201.Edit.vZB3k7CCdZy3cpUuCJhzy'), placeholder: '{# $ClassRoomID #}' },
            { label: window.vue.$i18n.t('M20701.M20701Store.mIWGlrmDojBD4epdO8Dei'), placeholder: '{# $CurriculumName #}' },
            { label: window.vue.$i18n.t('M20701.M20701Store.tqOODvT1lGI8kef9igFVN'), placeholder: '{# $BeforeApplicate #}' },
            { label: window.vue.$i18n.t('M20701.M20701Store.YiGNa1cN_VrtX4Ktmn856'), placeholder: '{# $AfterApplicate #}' },
            { label: window.vue.$i18n.t('C20101.Edit.xue-nian'), placeholder: '{# $Grade #}' },
            { label: window.vue.$i18n.t('M20701.M20701Store.8aEZiAx0lg4LU-CZC2LeQ'), placeholder: '{# $Course #}' },
            { label: window.vue.$i18n.t('M20701.M20701Store.a-n9Q-zRGdCv869TzCWyx'), placeholder: '{# $ApplicateCount #}' },
            { label: window.vue.$i18n.t('M20701.M20701Store.EsJ-by2l8fLasHzod1lQ0'), placeholder: '{# $ApplicateInfo #}' },
            { label: window.vue.$i18n.t('M20701.M20701Store.U9a9-qCYeZojrNhPLNNPX'), placeholder: '{# $Request #}' }
          ],
          Name: BUSINESS_DATA.APP_SHORT_TITLE+'太郎',
          Grade: '小６',
          ClassRoomID: 'h001',
          Course: '40分(後半)',
          CurriculumName: '数(算)ｱﾄﾞﾊﾞﾝｽ',
          BeforeApplicate: '2025/08/27&nbsp;水&nbsp;5講（後半）&nbsp;',
          AfterApplicate: '2025/07/15&nbsp;火&nbsp;7講（後半）&nbsp;',
          ApplicateCount: 0,
          Request: 'Test Request',
        }
      }
    }
  },

  mutations: {},

  actions: {
    async M20701_doBrowse_init ({ state, commit, rootState,dispatch }) {
      return await dispatch('M20701_doBrowse_AtDataTable');
    },
    async M20701_doBrowse_AtDataTable({dispatch, state}) {
      return await dispatch('doBrowse_AtDataTable', {
        orderBy: state.orderBy,
        pagination: state.pagination
      });
    },
    // async M20701_exportCSV ({ state }) {
    //   const res = await $this.$api.postData({
    //     data: [{
    //       api: 'M1031MailSettingService.M20701_exportCSV',
    //       input: { searchInfo: state.searchInfo }
    //     }]
    //   })
    //   return res[0].output;
    // },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
